module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"text":"Geriausias mūsų darbo įvertinimas - darbų kokybe bei rezultatu patenkinti klientai. Net 94% apklaustųjų atsakė, jog džiaugiasi suteiktomis paslaugomis, o bendradarbiavimą su Nogrid rekomenduotų ir draugui.","title":"94% mūsų apklaustų klientų rekomenduoja rinktis Nogrid"}}')
  delete Component.options._Ctor
}
